import { render, staticRenderFns } from "./areaChart.vue?vue&type=template&id=6545f10c"
import script from "./areaChart.vue?vue&type=script&lang=js"
export * from "./areaChart.vue?vue&type=script&lang=js"
import style0 from "./areaChart.vue?vue&type=style&index=0&id=6545f10c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports